import apiService from './api';

const nursingInjectionCatalogService = {
  list(params = {}) {
    return apiService.get('/nursing-injection-catalog', { params });
  },

  getById(id) {
    return apiService.get(`/nursing-injection-catalog/${id}`);
  },

  create(payload) {
    return apiService.post('/nursing-injection-catalog', payload);
  },

  update(id, payload) {
    return apiService.put(`/nursing-injection-catalog/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/nursing-injection-catalog/${id}`);
  }
};

export default nursingInjectionCatalogService;
